module.exports = __webpack_public_path__ + "static/img/dutch-flag.932bb89.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/dutch-flag.svg
// module id = oJWq
// module chunks = 103